export default function percentageCalc(value, total) {
  return Math.round((value / total) * 100)
}
